module.exports = __webpack_public_path__ + "static/img/banner-4.3a80a6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-4.png
// module id = P7kY
// module chunks = 1